import lowerFirst from '@Ravnur-Inc/nanoutils/string/lowerFirst';

import converter from './converter';

const toFrontendFormat = converter(lowerFirst);

export default toFrontendFormat;
